import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { HistoryAddedBlockDTO } from "../../HubSpot/useGetHubSpotCloserAvailabilityHistory.ts";
import { dayLabel } from "./closerAvailabilityHistoryStats.ts";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Europe/Rome";

export function HistoryChangesBlocksList({
  blocks,
}: {
  blocks: HistoryAddedBlockDTO[];
}) {
  if (blocks.length === 0) {
    return <p className="text-sm text-gray-400">Nessuno.</p>;
  }
  const time = (d: string) => dayjs(d).tz(TZ).format("HH:mm");
  return (
    <ul className="list-disc pl-5 text-sm space-y-0.5">
      {[...blocks]
        .sort((a, b) => a.slotStart.localeCompare(b.slotStart))
        .map((b) => (
          <li key={b.slotStart}>
            {dayLabel(b.date)} {time(b.slotStart)}–{time(b.slotEnd)} ·{" "}
            {b.eventTitle ?? "(senza titolo)"}{" "}
            <span className="text-red-600">(−{b.slots})</span>
          </li>
        ))}
    </ul>
  );
}
